import * as React from "react";

const AstericSymbol = ({ }) => {
  return (
    <span className="red_required_span">*</span>
  );
};

export default AstericSymbol;
